import api from './api';
import type {OperationsConfig, OperationsConfigUpdateRequest} from '../types/operations';

/** 系统级运营配置（系统报告生成白名单 + DCA 白名单/全局风控上限；ADMIN） */
export async function getOperationsConfig(): Promise<OperationsConfig | null> {
    const res = await api.get('/api/v1/operations-config');
    return res.data?.data ?? null;
}

/** 更新系统级运营配置（空字段不修改；ADMIN） */
export async function updateOperationsConfig(request: OperationsConfigUpdateRequest): Promise<OperationsConfig | null> {
    const res = await api.put('/api/v1/operations-config', request);
    return res.data?.data ?? null;
}
